import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { DToggleFormControl } from "../../entities/form-control";
import { FormField } from "../../entities/form-field";

@Component({
	selector: "form-toggle",
	template: `
		<div class="dynamic-field form-toggle" [formGroup]="group">
			<label>
				<ng-content select="h3" />

				<input type="checkbox" [formControlName]="config.name" />
			</label>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormToggleComponent implements FormField {
	@Input() config: DToggleFormControl;
	@Input() group: UntypedFormGroup;
}
